import {
  isMobileAtom,
  PAGE_NAME,
  removeSureUserId,
  Styles,
  useDetectMobile,
  useRecoil,
} from '@orcar/common-d2c';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { mobonTrackPageView } from '@/utils/mobon';
import MyPageWrapper from './MyPageWrapper';
import Footer from '../footer';
import MobileFooter from '../footer/components/MobileFooter';
import { CommonHeader } from '../header';
import ReservationStepper from '../reservation/ReservationStepper';

type LayoutProps = {
  children: React.ReactNode;
  isSearchPage?: boolean;
};

const Layout = ({ children }: LayoutProps) => {
  const { pathname } = useLocation();
  const { isMobile } = useDetectMobile();
  const { setRecoilState: setIsMobile } = useRecoil(isMobileAtom);

  const isHomePage = pathname === PAGE_NAME.index;
  const isFindReservationPage = pathname === PAGE_NAME.find_reservation;

  useEffect(() => {
    setIsMobile(isMobile);
  }, [isMobile]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // 모비온(원태그) SPA 방문 발화: 초기 로드는 tcs.js가 자동 발화하므로
  // 라우터 변경(두 번째 렌더부터)에서만 CallMtm을 호출한다.
  const hasTrackedInitialView = useRef(false);
  useEffect(() => {
    if (!hasTrackedInitialView.current) {
      hasTrackedInitialView.current = true;
      return;
    }
    mobonTrackPageView();
  }, [pathname]);

  useEffect(() => {
    removeSureUserId();
  }, []);

  return (
    <LayoutContainer
      isHomePage={isHomePage}
      backgroundColor={
        isFindReservationPage ? Styles.COLOR.WHITE : Styles.COLOR.GREY_BG
      }
    >
      <CommonHeader />
      <MainWrapper
        isMobile={isMobile}
        isHomePage={isHomePage}
        backgroundColor={
          isFindReservationPage ? Styles.COLOR.WHITE : Styles.COLOR.GREY_BG
        }
      >
        <ReservationStepper />
        <MyPageWrapper isMobile={isMobile}>{children}</MyPageWrapper>
      </MainWrapper>
      {isMobile && isHomePage && <MobileFooter />}
      {!isMobile && <Footer />}
    </LayoutContainer>
  );
};

export default Layout;

const LayoutContainer = styled.div<{
  isHomePage: boolean;
  backgroundColor?: string;
}>`
  position: relative;
  width: 100%;
  min-width: ${({ theme }) => theme.WIDTH.MOBILE_LAYOUT};
  min-height: 100vh;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.COLOR.WHITE};
`;

const MainWrapper = styled.main<{
  isMobile: boolean;
  isHomePage: boolean;
  backgroundColor?: string;
}>`
  margin: 0 auto;
  /* 홈은 히어로 배너를 화면 꽉 채우기 위해 풀와이드(100%). 그 외 페이지는 콘텐츠 폭에 맞춘다.
     히어로 내부 카피/검색바/섹션은 모두 max-width: PC_LAYOUT + 가운데 정렬이라 콘텐츠는 그대로 1200 컬럼에 유지된다. */
  width: ${({ isMobile, isHomePage }) =>
    !isMobile && (isHomePage ? '100%' : 'fit-content')};
  min-height: ${({ isMobile }) => isMobile && '100vh'};
  padding-top: ${({ isHomePage, theme }) =>
    isHomePage ? '0' : `calc(${theme.HEIGHT.PC_HEADER} + 44px)`};
  /* 하단 절대배치 푸터(대여사업자 바 포함으로 높이 증가) 위로 콘텐츠가 겹쳐
     잘리지 않도록 충분한 여백을 확보한다. */
  padding-bottom: 420px;
  background-color: ${({ theme, backgroundColor }) =>
    backgroundColor || theme.COLOR.WHITE};

  ${({ isMobile, isHomePage, theme }) =>
    isMobile &&
    css`
      padding-top: ${isHomePage ? '0' : theme.HEIGHT.MOBILE_HEADER};
      padding-bottom: 0;
    `};
`;
